import { Link } from "react-router-dom";

const SERVICES = [
  {
    icon: "ri-draft-line",
    title: "Projetos para Construção",
    desc: "Elaboramos projetos arquitetônicos e complementares completos, atendendo às normas técnicas e legislações vigentes.",
    color: "#2563EB",
  },
  {
    icon: "ri-government-line",
    title: "Regularização de Imóveis",
    desc: "Regularizamos edificações junto aos órgãos competentes, garantindo toda a documentação e legalização necessárias.",
    color: "#1E3A8A",
  },
  {
    icon: "ri-paint-brush-line",
    title: "Design de Interiores",
    desc: "Projetos de interiores que unem funcionalidade, estética e personalidade, criando ambientes únicos e sofisticados.",
    color: "#2563EB",
  },
  {
    icon: "ri-home-gear-line",
    title: "Design de Fachadas",
    desc: "Desenvolvemos fachadas modernas e impactantes que valorizam seu imóvel e refletem sua identidade.",
    color: "#1E3A8A",
  },
  {
    icon: "ri-tools-line",
    title: "Maquetes Eletrônicas",
    desc: "Visualizações 3D fotorrealistas que permitem ver seu projeto antes mesmo de iniciar a obra.",
    color: "#2563EB",
  },
  {
    icon: "ri-bank-line",
    title: "Financiamento de Imóveis",
    desc: "Assessoria completa para financiamento imobiliário, facilitando a realização do seu sonho com as melhores condições.",
    color: "#1E3A8A",
  },
];

export default function ServicesSection() {
  return (
    <section id="servicos" className="py-24" style={{ backgroundColor: "#1E3A8A" }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-[#C9A24A] text-xs font-semibold tracking-widest uppercase mb-3 block">
            O que oferecemos
          </span>
          <h2 className="text-white font-bold text-4xl md:text-5xl mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Nossos Serviços
          </h2>
          <div className="w-16 h-1 mx-auto" style={{ backgroundColor: "#C9A24A" }} />
          <p className="text-white/70 text-lg mt-5 max-w-2xl mx-auto">
            Soluções completas em engenharia e arquitetura para cada etapa do seu projeto imobiliário.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {SERVICES.map((service) => (
            <div
              key={service.title}
              className="bg-white rounded-xl p-8 group hover:scale-[1.02] transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-lg mb-5" style={{ backgroundColor: `${service.color}15` }}>
                <i className={`${service.icon} text-3xl`} style={{ color: service.color }} />
              </div>
              <h3 className="text-[#1F1F1F] font-bold text-xl mb-3" style={{ fontFamily: "'Poppins', sans-serif" }}>
                {service.title}
              </h3>
              <p className="text-[#7A7A7A] text-sm leading-relaxed">
                {service.desc}
              </p>
              <div className="mt-5 flex items-center gap-1 text-[#2563EB] text-sm font-medium group-hover:gap-2 transition-all">
                <span>Saiba mais</span>
                <i className="ri-arrow-right-line" />
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link
            to="/servicos"
            className="inline-flex items-center gap-2 border-2 border-white text-white hover:bg-white hover:text-[#1E3A8A] font-semibold px-8 py-4 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Ver Todos os Serviços
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
